export default {
  namespaced: true,
  state: {
    hotspot: {}
  },
  mutations: {
    SET_HOTSPOT(state, hotspot) {
      console.log('SET_HOTSPOT = ', hotspot)
      state.hotspot = hotspot
    }
  }
}
